import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: '/bookkeeping',
      name: 'bookkeeping',
      component: () => import('./views/Bookkeeping.vue')
    },
    {
      path: '/cards',
      name: 'cards',
      component: () => import('./views/Cards/Cards.vue')
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('./views/Service.vue')
    },
    {
      path: '/by-the-day',
      name: 'by-the-day',
      component: () => import('./views/OrdersByDay.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    }
  ]
})
